import React, { Component } from 'react';
import { observer, inject} from 'mobx-react';

@inject('oidcStore') @observer
export default class SilentRenewCallback extends Component {

    componentWillMount() {
        
        this.props.oidcStore.completeSilentRenew();
    }

    render(){
        
        return (
            null
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/account/silentRenewCallback.jsx